<template>
    <div class="p-6 mb-6 shadow-md rounded-md">
        <div class="text-2xl leading-6 flex justify-between items-center mb-4">
            <h3 class="font-bold">{{ stepTitle }}</h3>
            <p>Step {{ step }} of 5</p>
        </div>
        <h4 class="text-xl leading-6 font-bold mb-4">Diagnostic type</h4>
        <div class="mb-4 grid gap-6 md:grid-cols-2 max-w-2xl">
            <label v-for="surveyType in surveyTypes"
                   class="cursor-pointer flex justify-center text-center items-center px-8 py-7 leading-5 rounded-md focus:outline-none border border-dark"
                   :class="{
                            'bg-white' : surveyType.id !== selectedSurveyTypeId,
                            'bg-dark' : surveyType.id === selectedSurveyTypeId
                            }"
            >
                <input v-model="selectedSurveyTypeId" type="radio"
                       class="form-check rounded-sm border-2 w-5 h-5 focus:border-black focus:outline-none focus:shadow-outline-dark"
                       name="survey-type" :value="surveyType.id">
                <span class="ml-4 text-xl font-bold"
                      :class="{
                            'text-dark' : surveyType.id !== selectedSurveyTypeId,
                            'text-white': surveyType.id === selectedSurveyTypeId
                        }">
                    {{ surveyType.type }}</span>
            </label>
        </div>

        <template v-if="selectedSurveyTypeId">
            <div class="border-t border-dark pt-4">
                <h3 class="text-xl font-semibold leading-6 mb-4">Diagnostic template</h3>
                <label class="block pb-3">
                    <select v-model="form.surveyTemplate"
                            class="block w-full sm:w-1/2 md:w-full lg:w-1/2 text-lg leading-5 border-dark rounded-md focus:border-black focus:outline-none focus:shadow-outline-white focus:border-darkh focus:outline-none focus:shadow-outline-white form-select">
                        <option :value="null">Select template</option>
                        <option v-for="template in surveyTemplates[selectedSurveyTypeId]" :value="template">{{
                                template.name
                            }}
                        </option>
                    </select>
                </label>
            </div>
        </template>
    </div>

    <div class="flex justify-between">
        <jet-button :disabled="!form.surveyTemplate || form.processing" @click.prevent="nextStep"
                    class="ml-auto"
                    :bg-dark="true"
        >
            Next step
            <svg class="ml-2 h-3.5 w-2" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
            </svg>
        </jet-button>
    </div>
</template>

<script>
import JetButton from "@/Jetstream/Button";
import JetRadio from "@/Jetstream/Radio";
import {inject, ref, watch} from "vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";

export default {
    name: "SurveyEditorStepOne",
    components: {JetButton, JetRadio},
    props: {
        step: {
            type: Number,
            required: true
        },
        stepTitle: {
            type: String,
            required: true
        }
    },
    emits: ['next-step'],
    setup() {
        const selectedSurveyTypeId = ref(usePage().props.value.surveyTypeId ?? 0);
        const form = useForm({
            step: 1,
            surveyTemplate: null
        });

        const tenant = usePage().props.value.tenant;

        watch(selectedSurveyTypeId, () => {
            form.surveyTemplate = null;
        })

        const $swal = inject('$swal');

        const surveyTypes = usePage().props.value.surveyTypes || {};

        const surveyTemplates = usePage().props.value.surveyTemplates || {};

        const nextStep = () => {
            const selectedSurveyType = surveyTypes.filter(el => el.id === selectedSurveyTypeId.value)[0];
            $swal({
                title: 'Are you sure you want to create a ' + selectedSurveyType.type
                    + ' - ' + form.surveyTemplate.name + '?',
                text: "You won't be able to change this after creation!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, create it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.transform(({step, surveyTemplate}) => {
                        return {
                            step,
                            surveyTypeId: selectedSurveyTypeId.value,
                            surveyTemplateId: surveyTemplate.id
                        }
                    }).post(route('tenant.survey.store', tenant));
                }
            });

        }

        return {
            selectedSurveyTypeId,
            form,
            nextStep,
            surveyTypes,
            surveyTemplates,
        }
    }
}
</script>

<style scoped>

</style>
